var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observable, ApolloLink, } from '@apollo/client';
import { addTypenameToDocument, removeClientSetsFromDocument, } from '@apollo/client/utilities';
import delay from 'delay';
import stringify from 'fast-json-stable-stringify';
import { print, } from 'graphql';
export { withApolloMocks, hookWrapperWithApolloMocks, } from './utils';
export var MATCH_ANY_PARAMETERS = Symbol();
// MockedResponseWithMatchCount is a narrower type than WildcardMockedResponse so it
// has to be isNotWildcard rather than isWildcard
function isNotWildcard(mock) {
    return mock.request.variables !== MATCH_ANY_PARAMETERS;
}
var getResultFromFetchResult = function (result, variables) { return (typeof result === 'function' ? result(variables) : result); };
var toStoredOperation = function (op) { return ({
    query: op.query,
    variables: op.variables,
    context: op.getContext(),
}); };
var forwardResponseToObserver = function (observer, response, complete, act) {
    var result = response.result, error = response.error, delay = response.delay, request = response.request;
    if (result) {
        setTimeout(function () {
            act(function () {
                observer.next(getResultFromFetchResult(result, request.variables));
            });
            if (complete) {
                observer.complete();
            }
        }, delay);
    }
    else if (error) {
        setTimeout(function () {
            act(function () {
                observer.error(error);
            });
        }, delay);
    }
};
function isOperationDefinitionNode(node) {
    return node.operation !== undefined;
}
function callFunction(fun) {
    return fun();
}
var observableWithError = function (error) {
    return new Observable(function (observer) {
        observer.error(error);
    });
};
/**
 * Normalizes a WildcardMockedResponse removing @client directives from query
 */
var normalizeMockedResponse = function (mockedResponse) {
    var newMockedResponse = __assign({}, mockedResponse);
    var newQuery = removeClientSetsFromDocument(newMockedResponse.request.query);
    if (newQuery) {
        newMockedResponse.request.query = newQuery;
    }
    return newMockedResponse;
};
/**
 * Extends MockLink to provide the ability to match request queries independent
 * of their variables and have them match 1 or more responses. Also stores the
 * last request for use in assertion frameworks.
 */
var WildcardMockLink = /** @class */ (function (_super) {
    __extends(WildcardMockLink, _super);
    function WildcardMockLink(mockedResponses, options) {
        if (options === void 0) { options = {
            addTypename: true,
            suppressMissingMockWarnings: false,
        }; }
        var _a, _b, _c;
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.wildcardMatches = new Map();
        _this.regularMatches = new Map();
        _this.queries = [];
        _this.mutations = [];
        _this.subscriptions = [];
        _this.pendingResponses = new Set();
        _this.suppressMissingMockWarnings = false;
        _this.openSubscriptions = new Map();
        if (typeof options === 'boolean') {
            _this.act = callFunction;
            _this.addTypename = options;
        }
        else {
            _this.addTypename = (_a = options.addTypename) !== null && _a !== void 0 ? _a : true;
            _this.suppressMissingMockWarnings =
                (_b = options.suppressMissingMockWarnings) !== null && _b !== void 0 ? _b : false;
            _this.act = (_c = options.act) !== null && _c !== void 0 ? _c : callFunction;
        }
        mockedResponses.forEach(function (mockedResponse) {
            var normalizedMockResponse = normalizeMockedResponse(mockedResponse);
            _this.addMockedResponse(normalizedMockResponse);
        });
        return _this;
    }
    Object.defineProperty(WildcardMockLink.prototype, "lastQuery", {
        get: function () {
            return this.queries[this.queries.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WildcardMockLink.prototype, "lastMutation", {
        get: function () {
            return this.mutations[this.mutations.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WildcardMockLink.prototype, "lastSubscription", {
        get: function () {
            return this.subscriptions[this.subscriptions.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    WildcardMockLink.prototype.request = function (op) {
        var _this = this;
        var opDefNode = op.query.definitions.find(isOperationDefinitionNode);
        var operationType = opDefNode === null || opDefNode === void 0 ? void 0 : opDefNode.operation;
        if (operationType === 'subscription') {
            return this.requestSubscription(op);
        }
        if (operationType === 'mutation') {
            this.mutations.push(toStoredOperation(op));
        }
        else {
            this.queries.push(toStoredOperation(op));
        }
        var wildcardMock = this.getWildcardMockMatch(op);
        if (wildcardMock) {
            if (!wildcardMock.error && !wildcardMock.result) {
                return observableWithError(new Error('Must provide error or result for query/mutation mocks'));
            }
            var response = new Observable(function (observer) {
                forwardResponseToObserver(observer, wildcardMock, true, _this.act);
            });
            this.setLastResponsePromiseFromObservable(response);
            return response;
        }
        else {
            var regularMock_1 = this.getRegularMockMatch(op);
            if (!regularMock_1) {
                var errorString = "No mocks matched " + op.operationName + ": " + print(op.query) + ", variables: " + JSON.stringify(op.variables);
                if (!this.suppressMissingMockWarnings) {
                    console.warn(errorString);
                }
                return observableWithError(new Error(errorString));
            }
            else if (!regularMock_1.error && !regularMock_1.result) {
                return observableWithError(new Error('Must provide error or result for query/mutation mocks'));
            }
            var response = new Observable(function (observer) {
                forwardResponseToObserver(observer, regularMock_1, true, _this.act);
            });
            this.setLastResponsePromiseFromObservable(response);
            return response;
        }
    };
    WildcardMockLink.prototype.requestSubscription = function (op) {
        var _this = this;
        this.subscriptions.push(toStoredOperation(op));
        var wildcardMock = this.getWildcardMockMatch(op);
        if (wildcardMock) {
            return new Observable(function (observer) {
                _this.openSubscriptions.set(_this.queryToString(op.query), observer);
                forwardResponseToObserver(observer, wildcardMock, false, _this.act);
            });
        }
        else {
            var regularMock_2 = this.getRegularMockMatch(op);
            if (!regularMock_2) {
                var errorString = "No mocks matched " + op.operationName + ": " + print(op.query) + ", variables: " + JSON.stringify(op.variables);
                if (!this.suppressMissingMockWarnings) {
                    console.warn(errorString);
                }
                return observableWithError(new Error(errorString));
            }
            return new Observable(function (observer) {
                // if there are multiple subscriptions for the same request with the
                // same variables, the last one will be lost
                _this.openSubscriptions.set(_this.queryAndVariablesToString(op.query, op.variables), observer);
                forwardResponseToObserver(observer, regularMock_2, false, _this.act);
            });
        }
    };
    /**
     * Send a new response to the open subscription matching `request`. This does not
     * work for subscriptions that matched wildcard requests.
     */
    WildcardMockLink.prototype.sendSubscriptionResult = function (request, variables, response) {
        var subscription = this.openSubscriptions.get(this.queryAndVariablesToString(request, variables));
        if (!subscription) {
            throw new Error('Could not send subscription result for subscription that is not open');
        }
        else {
            this.act(function () {
                subscription.next(response);
            });
        }
    };
    /**
     * Send a new response to the open subscription matching `request`. This only
     * works for subscriptions that matched wildcard requests.
     */
    WildcardMockLink.prototype.sendWildcardSubscriptionResult = function (request, response) {
        var subscription = this.openSubscriptions.get(this.queryToString(request));
        if (!subscription) {
            throw new Error('Could not send subscription result for subscription that is not open');
        }
        else {
            this.act(function () {
                subscription.next(response);
            });
        }
    };
    /**
     * Close the subscription matching `request`.
     */
    WildcardMockLink.prototype.closeSubscription = function (request) {
        var cacheKey = this.queryToString(request);
        var subscription = this.openSubscriptions.get(cacheKey);
        if (!subscription) {
            throw new Error('Could not close subscription subscription that is not open');
        }
        else {
            subscription.complete();
            this.openSubscriptions.delete(cacheKey);
        }
    };
    WildcardMockLink.prototype.addMockedResponse = function () {
        var _this = this;
        var responses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            responses[_i] = arguments[_i];
        }
        responses.forEach(function (response) {
            var _a;
            if (isNotWildcard(response)) {
                var mockKey = _this.queryAndVariablesToString(response.request.query, response.request.variables);
                var matchesForKey = _this.regularMatches.get(mockKey);
                if (matchesForKey) {
                    matchesForKey.push(response);
                }
                else {
                    _this.regularMatches.set(mockKey, [response]);
                }
            }
            else {
                var mockKey = _this.queryToString(response.request.query);
                var storedMocks = _this.wildcardMatches.get(mockKey);
                var storedMock = {
                    result: response.result,
                    nMatches: response.nMatches,
                    delay: (_a = response.delay) !== null && _a !== void 0 ? _a : 0,
                    request: __assign(__assign({}, response.request), { variables: response.request.variables === MATCH_ANY_PARAMETERS
                            ? undefined
                            : response.request.variables }),
                };
                if (storedMocks) {
                    storedMocks.push(storedMock);
                }
                else {
                    _this.wildcardMatches.set(mockKey, [storedMock]);
                }
            }
        });
    };
    /**
     * Remove the wildcard mocked response for `request`.
     */
    WildcardMockLink.prototype.removeWildcardMockedResponse = function (request) {
        this.wildcardMatches.delete(this.queryToString(request));
    };
    /**
     * Return true if the last query request matches the argument.
     */
    WildcardMockLink.prototype.lastQueryMatches = function (request) {
        return (!!this.lastQuery &&
            this.queryToString(request) === this.queryToString(this.lastQuery.query));
    };
    /**
     * Return true if the last query request matches the argument.
     */
    WildcardMockLink.prototype.lastMutationMatches = function (request) {
        return (!!this.lastMutation &&
            this.queryToString(request) ===
                this.queryToString(this.lastMutation.query));
    };
    /**
     * Return true if the last subscription request matches the argument.
     */
    WildcardMockLink.prototype.lastSubscriptionMatches = function (request) {
        return (!!this.lastSubscription &&
            this.queryToString(request) ===
                this.queryToString(this.lastSubscription.query));
    };
    /**
     * Wait for the response of the last query or mutation.
     * It cannot wait for responses from subscriptions because they remain open.
     */
    WildcardMockLink.prototype.waitForLastResponse = function () {
        var _this = this;
        if (this.lastResponse) {
            return this.act(function () { return _this.lastResponse; });
        }
        else {
            return Promise.resolve();
        }
    };
    /**
     * Wait for the all responses that are currently pending.
     */
    WildcardMockLink.prototype.waitForAllResponses = function () {
        var _this = this;
        return this.act(function () {
            return Promise.all(Array.from(_this.pendingResponses));
        });
    };
    /**
     * Wait for all responses that are currently pending, and all responses that are triggered
     * as a result of those responses being sent.
     * @param requestWindow How long to wait between between requests for a new request to be
     *        made, by default use 0 which allows one tick.
     */
    WildcardMockLink.prototype.waitForAllResponsesRecursively = function (requestWindow) {
        var _this = this;
        if (requestWindow === void 0) { requestWindow = 0; }
        var runWait = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.pendingResponses.size) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Promise.all(Array.from(this.pendingResponses))
                            // allow code to issue new requests within the request window
                        ];
                    case 1:
                        _a.sent();
                        // allow code to issue new requests within the request window
                        return [4 /*yield*/, delay(requestWindow)];
                    case 2:
                        // allow code to issue new requests within the request window
                        _a.sent();
                        return [4 /*yield*/, runWait()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return this.act(runWait);
    };
    WildcardMockLink.prototype.queryToString = function (query) {
        return print(this.addTypename ? addTypenameToDocument(query) : query);
    };
    WildcardMockLink.prototype.queryAndVariablesToString = function (query, variables) {
        return this.queryToString(query) + stringify(variables !== null && variables !== void 0 ? variables : {});
    };
    /**
     * Get wildcard mock match, if it exists, also removing the mock (or
     * decrementing its match count) as necessary.
     */
    WildcardMockLink.prototype.getWildcardMockMatch = function (op) {
        var mockKey = this.queryToString(op.query);
        var mocks = this.wildcardMatches.get(mockKey);
        if (!mocks) {
            return undefined;
        }
        var nextMock = mocks[0];
        if (nextMock.nMatches === undefined || --nextMock.nMatches === 0) {
            mocks.shift();
            if (!mocks.length) {
                this.wildcardMatches.delete(mockKey);
            }
        }
        return __assign(__assign({}, nextMock), { request: __assign(__assign({}, nextMock.request), { variables: op.variables }) });
    };
    WildcardMockLink.prototype.getRegularMockMatch = function (op) {
        var mockKey = this.queryAndVariablesToString(op.query, op.variables);
        var mocks = this.regularMatches.get(mockKey);
        if (!mocks) {
            return undefined;
        }
        var nextMock = mocks[0];
        if (nextMock.nMatches === undefined || --nextMock.nMatches === 0) {
            mocks.shift();
            if (!mocks.length) {
                this.regularMatches.delete(mockKey);
            }
        }
        return nextMock;
    };
    WildcardMockLink.prototype.setLastResponsePromiseFromObservable = function (observable) {
        var _this = this;
        if (observable) {
            var responsePromise_1 = new Promise(function (resolve) {
                var resolvePromise = function () {
                    resolve();
                    _this.pendingResponses.delete(responsePromise_1);
                };
                observable.subscribe(resolvePromise, resolvePromise);
            });
            this.lastResponse = responsePromise_1;
            this.pendingResponses.add(responsePromise_1);
        }
    };
    return WildcardMockLink;
}(ApolloLink));
export { WildcardMockLink };
//# sourceMappingURL=index.js.map